import type { DataTableColumn } from '@/components/custom/erp';
import type { PhuongThucGiaoHang } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<PhuongThucGiaoHang>[] => [
  {
    field: 'ma_ptgh',
    headerName: 'Phương thức',
    width: 150
  },
  {
    field: 'ten_ptgh',
    headerName: 'Diễn giải',
    width: 250
  }
];
